import { svgIconClasses } from '@mui/material/SvgIcon'
import { typographyClasses } from '@mui/material/Typography'
import { buttonBaseClasses } from '@mui/material/ButtonBase';
import { alpha } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }) => ({
			[`& .${svgIconClasses.root}`]: {
				width: '1rem',
				height: '1rem',
				color: (theme.vars || theme).palette.text.secondary,
			},
			[`& .${typographyClasses.root}`]: {
				fontWeight: 500,
			},
			[`& .${buttonBaseClasses.root}`]: {
				display: 'flex',
				gap: 8,
				padding: '2px 8px',
				borderRadius: (theme.vars || theme).shape.borderRadius,
				opacity: 0.7,
				'&.Mui-selected': {
					opacity: 1,
					backgroundColor: alpha(theme.palette.action.selected, 0.3),
					[`& .${svgIconClasses.root}`]: {
						color: (theme.vars || theme).palette.text.primary,
					},
					'&:focus-visible': {
						backgroundColor: alpha(theme.palette.action.selected, 0.3),
					},
					'&:hover': {
						backgroundColor: alpha(theme.palette.action.selected, 0.5),
					},
				},
				'&:focus-visible': {
					backgroundColor: 'transparent',
				},
			},
		}),
	},
}
